// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V2R2","expireSoon":"styles_expireSoon__3kR2L"};